import Appily from '../assets/recommendations/Appily.jpeg'
import Avvo from '../assets/recommendations/Avvo.png'
import CarGurus from '../assets/recommendations/CarGurus.png'
import Credible from '../assets/recommendations/Credible.png'
import FreeTaxFile from '../assets/recommendations/freetaxfile.svg'
import HealthcareGov from '../assets/recommendations/HealthcareGov.png'
import Lemonade from '../assets/recommendations/Lemonade.svg'
import MonarchMoney from '../assets/recommendations/MonarchMoney.svg'
import PolicyGenius from '../assets/recommendations/PolicyGenius.svg'
import Redfin from '../assets/recommendations/Redfin.jpg'
import Sofi from '../assets/recommendations/sofi.png'
import Wealthfront from '../assets/recommendations/wealthfront.png'
import CC from '../assets/videos/creditcard.svg'
import { Product } from '../components/Product'
import type { Choices } from '../pages/recommendations'
import {
  creditCardsExplanation,
  insuranceExplanation,
  loanExplanation,
} from './Explanations'
import { creditCardWarning, loanWarning } from './Warnings'

export const ChoiceList = () => {
  const choices: Record<Choices, any> = {
    'Bank-Account-Checking': (
      <Product
        icon={Sofi.src}
        title={'Online Checking Account'}
        company={'SoFi'}
        link={'https://www.sofi.com/banking/checking-account/'}
        product={'online-only checking accounts'}
        specificProduct={'this account'}
        specificExplanation="We like the SoFi checking
            account because it has zero fees, excellent interest rates, and great customer service where you can get a
            real human on the line in less than 10 minutes. At the
            end of the day, most online-only banks are quite similar, so you simply
            want one that is reliable and just works. SoFi is that bank!"
        generalExplanation="They usually have no
            maintenance fees, allow you to withdraw cash from any bank's ATM, and have
            much higher interest rates than standard accounts. An excellent option
            unless you need to deposit cash."
      />
    ),
    'Bank-Account-Savings': (
      <Product
        icon={Sofi.src}
        title={'High-Yield Savings Account'}
        company={'SoFi'}
        link={'https://www.sofi.com/banking/savings-account/'}
        product={'online-only savings accounts'}
        specificProduct={'this savings account'}
        specificExplanation="We like the SoFi
            savings account because it has zero fees, excellent interest rates, and a
            strong integration with their checking account. At the end of the day, all
            you need with a savings account is rates that are
            consistently near the top and the ability to transfer
            money instantly and without cost to your linked checking account at that
            same bank. SoFi is that bank!"
        generalExplanation="They usually have no
            maintenance fees and much higher interest rates than standard accounts."
      />
    ),
    'Credit-Card-Balance-Transfer': (
      <Product
        icon={CC.src}
        warning={creditCardWarning()}
        title={'No Recommendation'}
        company={''}
        link={''}
        product={'balance transfer cards'}
        generalExplanation={creditCardsExplanation('balance transfer cards')}
        specificExplanation=""
      />
    ),
    'Credit-Card-Secured': (
      <Product
        icon={CC.src}
        warning={creditCardWarning()}
        title={'No Recommendation'}
        company={''}
        link={''}
        product={'secured cards'}
        generalExplanation={creditCardsExplanation('secured cards')}
        specificExplanation=""
      />
    ),
    'Credit-Card-Rewards': (
      <Product
        icon={CC.src}
        warning={creditCardWarning()}
        title={'No Recommendation'}
        company={''}
        link={''}
        product={'rewards cards'}
        generalExplanation={creditCardsExplanation('rewards cards')}
        specificExplanation=""
      />
    ),
    'Credit-Card-Student': (
      <Product
        icon={CC.src}
        warning={creditCardWarning()}
        title={'No Recommendation'}
        company={''}
        link={''}
        product={'student cards'}
        generalExplanation={creditCardsExplanation('student cards')}
        specificExplanation=""
      />
    ),
    'Insurance-Car': (
      <Product
        icon={PolicyGenius.src}
        title={'PolicyGenius'}
        link={'https://www.policygenius.com/'}
        product={'car insurance'}
        specificExplanation={insuranceExplanation(
          'car insurance',
          'PolicyGenius'
        )}
        generalExplanation="Beyond the fact it's legally
            required? Because the last thing you want is to ruin your
            financial life because your totaled your car, or God forbid, hit someone
            and need to pay their medical expenses."
      />
    ),
    'Insurance-Health': (
      <Product
        icon={HealthcareGov.src}
        title={'Healthcare.gov'}
        company={'The Federal Government'}
        link={'https://www.healthcare.gov/'}
        product={'health insurance'}
        specificProduct={'Healthcare.gov'}
        specificExplanation="Beyond the fact it is the only game
            in town? Because the government actually did a really good job with the
            website! It is easy to compare different plans and get help from a real
            human on the phone. Oh, and it's free! What else could you want?"
        generalExplanation="Honestly, it's harder to come up
            with a reason not to get health insurance. Not only does
            it help protect you from the most common source of bankruptcy, medical
            expenses, you get to take advantage of the lowered costs your insurer has
            negotiated with your provider."
      />
    ),
    'Insurance-Homeowners': (
      <Product
        icon={PolicyGenius.src}
        title={'PolicyGenius'}
        link={'https://www.policygenius.com/'}
        product={'homeowners insurance'}
        specificExplanation={insuranceExplanation(
          'homeowners insurance',
          'PolicyGenius'
        )}
        generalExplanation="While homeowners insurance is
            not legally required, it's a really good idea. Not only is homeowners
            insurance not that expensive, it will keep your financial life from being
            ruined by something like your house being burned down or God forbid,
            someone being seriously injured on your property"
      />
    ),
    'Insurance-Life': (
      <Product
        icon={PolicyGenius.src}
        title={'PolicyGenius'}
        link={'https://www.policygenius.com/'}
        product={'life insurance'}
        specificExplanation={insuranceExplanation(
          'term life insurance',
          'PolicyGenius'
        )}
        generalExplanation="If you have someone dependent on
            your income, life insurance is absolutely a must. After all, if you died,
            who would provide that income to that dependent?"
      />
    ),
    'Insurance-Long-Term-Disability': (
      <Product
        icon={PolicyGenius.src}
        title={'PolicyGenius'}
        link={'https://www.policygenius.com/'}
        product={'long-term disability insurance'}
        specificExplanation={insuranceExplanation(
          'long-term disability insurance',
          'PolicyGenius'
        )}
        generalExplanation="Why long-term disability: If you depend on your job for
            income (like most people) long-term disability insurance is a must. After
            all, if you got sick or suffered a debilitating injury that rendered you
            unable to work, how else would be able to support yourself? Long-term
            disability insurance also isn't that expensive, especially for the value
            it provides!"
      />
    ),
    'Insurance-Renters': (
      <Product
        icon={Lemonade.src}
        title={'Lemonade'}
        link={'https://www.lemonade.com'}
        product={'renters insurance'}
        specificProduct={'Lemonade'}
        specificExplanation="Lemonade is a bit of an odd duck in the
            insurance industry, but I say that in the nicest way possible. Not only is
            their coverage A+ and their costs rock bottom, they're also a public
            benefit corporation. They take a flat fee to run everything and then if
            there's money leftover, they give it back to causes. Essentially the
            inverse of a traditional insurance company. How cool is that?"
        generalExplanation="Most people think they don't need
            renters insurance. To put it mildly, they are wrong! Not only will your
            landlord not cover your possessions if they are stolen, they also will not
            cover you if someone is injured in your apartment. Renters insurance is
            also crazy cheap, often less than $100 a year"
      />
    ),
    'Loan-Auto': (
      <Product
        icon={Credible.src}
        warning={loanWarning()}
        title={'Credible'}
        link={'https://www.credible.com/personal-loan/auto-loans'}
        product={'auto loans'}
        specificExplanation={loanExplanation('auto loans', 'Credible')}
        generalExplanation="While we don't love auto loans, and
            recommend paying for a used car in cash whenever possible, for some people
            that just isn't possible. That is when auto loans can be a true lifesaver,
            especially if you need a car to commute to work"
      />
    ),
    'Loan-Home': (
      <Product
        icon={Credible.src}
        warning={loanWarning()}
        title={'Credible'}
        link={'https://www.credible.com/mortgage'}
        product={'home loans'}
        specificExplanation={loanExplanation('home loans', 'Credible')}
        generalExplanation="Simply put, they make buying a home
            possible. Otherwise, home ownership would remain out of reach for the vast
            majority of Americans, who barely have $2,000 lying around, let alone
            $200,000!"
      />
    ),
    'Loan-Personal': (
      <Product
        icon={Credible.src}
        warning={loanWarning()}
        title={'Credible'}
        link={'https://www.credible.com/personal-loan'}
        product={'personal loans'}
        specificExplanation={loanExplanation('personal loans', 'Credible')}
        generalExplanation="Personal loans can be a great way to
            consolidate high interest credit card onto one loan with
            a lower interest rate and a fixed payment."
      />
    ),
    'Loan-Student': (
      <Product
        icon={Credible.src}
        warning={loanWarning()}
        title={'Credible'}
        link={'https://www.credible.com/'}
        product={'student loans'}
        specificExplanation={loanExplanation('student loans', 'Credible')}
        generalExplanation="Do we even really need to say it?
            Private student loans can make paying for (ludicrously expensive) higher education possible.
            As for refinancing, it is an excellent way to get a lower interest rate on
            your exist student loans as long as you are comfortable forfeiting the
            protection of federal student loans."
      />
    ),
    'Other-Car-Buying': (
      <Product
        icon={CarGurus.src}
        title={'CarGurus'}
        link={'https://www.cargurus.com'}
        product={'car buying websites'}
        specificProduct={'this website'}
        specificExplanation="Of all the car buying websites, we like CarGurus the best. It has the cleanest interface and an enormous selection of listings.
        And it is free! Honestly, what more could you want from this type of website?"
        generalExplanation="Buying a used car with a dealership while 'flying blind' is a bad idea. The car buying website solves this problem. 
        You can view every make and model of car in your area, understand whether the price is good or not, and more!"
      />
    ),
    'Other-Home-Buying': (
      <Product
        icon={Redfin.src}
        title={'Redfin'}
        link={'https://www.redfin.com'}
        product={'home buying websites'}
        specificProduct={'this website'}
        specificExplanation="Simply put, Redfin makes buying and
            selling a home as easy as it should be! Not only is their technology
            best-in-class, making it easy to view a home, book an agent, and more, the
            numbers speak for themselves. Customer satisfaction for Redfin is 50%
            higher than industry average based on a May 2019 survey and customers
            save, on average, $8,200, partially due to a reduced listing fee."
        generalExplanation="Buying a house is both
            stressful and difficult! Home buying websites solve this problem by making
            easy to connect with an agent, tour homes, browse available homes in your
            area, and more. They also tend to save you money relative to traditional
            realtors."
      />
    ),
    'Other-Legal': (
      <Product
        icon={Avvo.src}
        title={'Avvo'}
        link={'https://www.avvo.com/'}
        product={'legal websites'}
        specificProduct={'this legal website'}
        specificExplanation="Honestly, while I'm sure there
            are other legal websites, Avvo has always seemed more than enough for
            basically any need. Large directory of lawyers, tons of reviews, excellent
            user interface, and an agreeable price tag, free! What more could you ask
            for?"
        generalExplanation="Because sometimes you just need a
            lawyer, and finding a good one is much harder then it needs to be! Legal
            websites make it easy to search for specific types of lawyers, read
            reviews of their services, and more. They're a great way to bring
            transparency to an otherwise confusing process"
      />
    ),
    'Other-Scholarships': (
      <Product
        icon={Appily.src}
        title={'Appily'}
        link={'https://www.appily.com/'}
        product={'scholarships'}
        specificProduct={'this website'}
        specificExplanation="When it comes to scholarship websites,
            you basically want three things: a bunch of scholarships you can apply
            for, an excellent user interface, and a great price, ideally free! On all
            three dimensions Appily is a winner. Not only is Appily free, it also
            offers the nation's largest, multi-billion dollar scholarship database."
        generalExplanation="Because college is expensive! So any
            money you can get to offset the money you would have to
            pay is a win in our book"
      />
    ),
    'Other-Spending-Plans': (
      <Product
        icon={MonarchMoney.src}
        title={'Monarch Money'}
        link={'https://www.monarchmoney.com/'}
        product={'spending plans'}
        specificProduct={'this spending plan'}
        specificExplanation="Having tried many apps in this space, we feel that Monarch Money is the gold standard for a reason. 
        It can do everything from link accounts, to automatically calculate budgets, to your track net worth. It is awesome!
        It costs $100 per year, billed annually, which we feel is a very fair price for what you get. However, if that is too much money, you can always (crudely) track your spending in Google Sheets, which is free!"
        generalExplanation="Because tracking all of your expenses manually is a pain in the butt.
        It is way easier to just securely link your accounts and let the software calculate stuff like your net worth, the amount you spend on groceries, and so on."
      />
    ),
    'Other-Tax-Software': (
      <Product
        icon={FreeTaxFile.src}
        title={'FreeTaxUsa'}
        company={'FreeTaxUsa'}
        link={'https://www.freetaxusa.com/'}
        product={'tax-software'}
        specificProduct={'this tax software'}
        specificExplanation="We like FreeTaxUsa because
            it is really cheap ($15 for your federal return and one state return) and fully featured. Seriously. Unless you own a business and
            need to file taxes for that business, FreeTaxUsa should have you
            covered. Honestly, one of the rare products in this industry that is as
            good as advertised."
        generalExplanation="Honestly, I have more trouble coming up
            with a reason to not use tax paying software. Not only is
            it free for most people, it keeps you from, you know, having to actually
            read the tax code and fill out a bunch of paper forms. Truly a win for the
            consumer!"
      />
    ),
    'Robo-Advisors': (
      <Product
        icon={Wealthfront.src}
        title={'Wealthfront'}
        link={'https://www.wealthfront.com/investing'}
        product={'robo-advisors'}
        specificProduct={'this website'}
        specificExplanation="Look, there are a
            lot of robo-advisors out there now. However, we feel that
            Wealthfront provides the best all-around value: a $500 minimum deposit, a
            0.25% annual fee, a full suite of features, like tax-loss harvesting,
            and a solidly constructed portfolio. What more could you ask for?"
        generalExplanation="Honestly? Because investing is
            intimidating and robo-advisors make the process basically as easy as can
            be. For a nominal fee, like 0.25% of assets, they'll construct a balanced
            portfolio of index funds. They also come with slick interface and cool
            features like tax-loss harvesting and automatic rebalancing. Truly an
            excellent 'set it and forget it' option!"
      />
    ),
  }
  return choices
}
